import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { TaskListEntity } from '../../ui/components/app-task-modal/app-task-list.entity';
import { featureSelector, IAppRootState } from './feature.store';
import { TaskSliceKey, TaskSliceState } from './task.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[TaskSliceKey]
);

@Injectable()
export class TaskSelector {
	public constructor(private readonly store: Store<IAppRootState>) {}

	private get state(): Observable<TaskSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public isLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getTaskList$(): Observable<TaskListEntity> {
		return this.state.pipe(map((state) => state.get('list')));
	}

	public getViewActiveJobs$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('viewActiveJobs')));
	}
}
